/**
 * IconCheckCustom component - Custom check icon for spot comparator.
 */
export function IconCheckCustom() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_4540_866)">
        <path d="M5 12L10 17L20 7" stroke="#50C66E" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4540_866">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
